import React from 'react';
import './AboutUs.css';

const AboutUs = () => (
  <section className="static-page">
    <h1>About Us</h1>
    <p>MyApoti is a digital platform designed to help individuals locate verified pharmacies and find essential drugs quickly and securely. We aim to bridge the gap between users and trusted pharmaceutical outlets, ensuring that healthcare access is easier, faster, and more transparent.</p>
    <p>Our mission is to reduce the stress of drug search, minimize counterfeit exposure, and promote health access using smart technology and real-time data.</p>
    <p>Whether you're looking for a specific medication or comparing nearby pharmacies, MyApoti brings peace of mind to your healthcare journey.</p>
  </section>
);

export default AboutUs;
